import React, {memo} from 'react'
import Style from "./FJLogo.module.less";
import InlineSVG from "react-inlinesvg";
import FJWebLogoIcon from "../../../icon/product logo.svg";

function FJLogo(props) {
  let {onClick} = props;
  return (
    <div className={Style.logo} onClick={onClick}>
      <InlineSVG src={FJWebLogoIcon}/>
    </div>
  );
}

export default memo(FJLogo);